// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1yqsJ","col":"styles_col__E1k02"};